//#region frontend/islands/science-tooltip.js
var ScienceTooltip = class extends window.HTMLElement {
	connectedCallback() {
		this.circle = this.querySelector(".science-progress-circle");
		if (!this.circle) return;
		this._activate = () => this.classList.add("is-active");
		this._deactivate = () => this.classList.remove("is-active");
		this.circle.addEventListener("mouseenter", this._activate);
		this.addEventListener("mouseleave", this._deactivate);
		this.circle.addEventListener("focus", this._activate);
		this.circle.addEventListener("blur", this._deactivate);
	}
	disconnectedCallback() {
		this.circle?.removeEventListener("mouseenter", this._activate);
		this.removeEventListener("mouseleave", this._deactivate);
		this.circle?.removeEventListener("focus", this._activate);
		this.circle?.removeEventListener("blur", this._deactivate);
	}
};
window.customElements.define("science-tooltip", ScienceTooltip);
//#endregion
